import React from "react";

import { LEGAL_LINKS } from "../../config/legalLinks";
import { getAppVersionDisplay } from "../../helpers/appVersionDisplay";
import { openExternalUrl } from "../../helpers/openExternalUrl";

function DocumentIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6M8 13h8M8 17h8M8 9h2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function AccountDeletionIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M9 9h6M9 13h6M10 21h4a2 2 0 0 0 2-2V5H8v14a2 2 0 0 0 2 2Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3V1M5 3h14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function VersionIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M12 10v6M12 7.5v.01"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="m9 6 6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LegalLinkRow({ icon, label, url }) {
  const handleClick = () => {
    openExternalUrl(url);
  };

  return (
    <button
      type="button"
      className="user-preferences__link-row"
      onClick={handleClick}
    >
      <span className="user-preferences__link-icon">{icon}</span>
      <span className="user-preferences__link-label">{label}</span>
      <span className="user-preferences__link-chevron">
        <ChevronIcon />
      </span>
    </button>
  );
}

function VersionRow({ version, build }) {
  return (
    <div className="user-preferences__link-row user-preferences__link-row--static">
      <span className="user-preferences__link-icon">
        <VersionIcon />
      </span>
      <span className="user-preferences__link-label">Version</span>
      <span className="user-preferences__version-meta">
        <span className="user-preferences__version-line">Version {version}</span>
        {build ? (
          <span className="user-preferences__version-line">Build {build}</span>
        ) : null}
      </span>
    </div>
  );
}

export function AboutLegalSection() {
  const { version, build } = getAppVersionDisplay();

  return (
    <section
      className="user-preferences__group user-preferences__about-legal"
      aria-labelledby="user-preferences-about-legal-heading"
    >
      <h3
        id="user-preferences-about-legal-heading"
        className="user-preferences__heading"
      >
        About &amp; Legal
      </h3>

      <LegalLinkRow
        icon={<DocumentIcon />}
        label="Privacy Policy"
        url={LEGAL_LINKS.privacyPolicy}
      />
      <LegalLinkRow
        icon={<DocumentIcon />}
        label="Terms of Service"
        url={LEGAL_LINKS.termsOfService}
      />
      <LegalLinkRow
        icon={<AccountDeletionIcon />}
        label="Account Deletion"
        url={LEGAL_LINKS.accountDeletion}
      />
      <VersionRow version={version} build={build} />
    </section>
  );
}
